import { render, staticRenderFns } from "./AboutEdit.vue?vue&type=template&id=a6645b6c&scoped=true"
import script from "./AboutEdit.vue?vue&type=script&lang=js"
export * from "./AboutEdit.vue?vue&type=script&lang=js"
import style0 from "./AboutEdit.vue?vue&type=style&index=0&id=a6645b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6645b6c",
  null
  
)

export default component.exports